module.exports = __webpack_public_path__ + "src/assets/img/paper.92e0e757.jpg";